import React, { useEffect, useState } from "react";
import { Modal, ModalBody, Spinner } from "reactstrap";
import InfoMessage from "./InfoMessage";
import { Link } from "gatsby";
const infoIcon: string = require("../../assets/images/blue-info-icon.svg").default;

interface RequestDemoModalProps {
  isOpen: boolean;
  toggle: (event: React.MouseEvent | React.KeyboardEvent) => void;
  closeModal: () => void;
}

const RequestDemoModal = ({ isOpen, toggle, closeModal }: RequestDemoModalProps) => {
  const [isFormLoaded, setIsFormLoaded] = useState(false);

  
  useEffect(() => {
    if (isOpen) {
      setIsFormLoaded(false); 
      setTimeout(() => {
        setIsFormLoaded(true);
      }, 500); 
    } else {
      setIsFormLoaded(false);
    }
  }, [isOpen]);

  return (
    <React.Fragment>
      <Modal className="custom-modal" isOpen={isOpen} toggle={toggle} centered fade={true}>
        <div className="custom-modal-header">
          <button type="button" className="btn-close ms-auto p-2" aria-label="Close" onClick={closeModal} />
          <h1 className="title">Request a demo</h1>
        </div>
        <ModalBody className="custom-modal-body">
          <div className="request-demo-info w-100">
            <img src={infoIcon} className="me-2" />
            <div className="description">
              This demo request form is intended <strong>only for dealers.</strong><br />
              If you are not a dealer, please use the <Link to="/contact-us#contact-form" onClick={() => closeModal()}>Contact us form</Link> for more information.
            </div>
          </div>
          {isFormLoaded ? 
            <div
              className="hs-form-frame"
              data-region="na1"
              data-form-id="9ba92e7a-baf7-414b-98ea-c2b8620c4437"
              data-portal-id="48528424"
           /> : <Spinner color="primary" className="d-flex mx-auto" />}
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default RequestDemoModal;
